<ion-app uve-themes [attr.data-qa-id]="'ion-app'" [class.hide-app]="hideApp()">
  <app-menu
    [swipeGesture]="swipeGesture()"
    [user]="authService?.uveUser"
    [currentUrl]="currentUrl()"
    [version]="version()" />

  <ion-router-outlet id="main-content" />
  <app-splash />
  <app-loading />

  <!-- Toast notifications container -->
  <div toastContainer></div>
</ion-app>

@if (hideApp()) {
  <div class="scanner-container">
    <div class="scanner-area-container">
      <div class="square surround-cover">
        <div class="scanner-area-outer surround-cover">
          <div class="scanner-area-inner"></div>
        </div>
      </div>
      <div class="stop-wrapper">
        <ion-button
          color="primary"
          shape="round"
          expand="block"
          class="stop-scanner"
          (click)="scannerService.stopScan()">
          {{ 'stop_scan' | uvetranslate }}
        </ion-button>
      </div>
    </div>
  </div>
}
